module.exports = __webpack_public_path__ + "static/media/Paloma Ave, Burlingame, CA11.1dc7a98c.jpg";